exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0bcc460b]:deep(#package-form-assign-Modal .modal-dialog){max-width:96vw;width:96vw;margin:1rem auto}[data-v-0bcc460b]:deep(#package-form-assign-Modal .modal-body){min-height:70vh;max-height:none;overflow-y:visible}[data-v-0bcc460b]:deep(#package-form-assign-Modal .modal-content){overflow:visible}[data-v-0bcc460b]:deep(#package-form-assign-Modal .dropdown-menu),[data-v-0bcc460b]:deep(#package-form-assign-Modal .v-select-page){max-height:320px}", ""]);

// exports
